/// <amd-module name="Test/TestPlansHubRefresh/TestPlansSegment/Utils/TestPlanResultsSource" />
import { AnalyticsODataClientBase } from "Analytics/Shared/Common/Sources/AnalyticsODataClientBase";
import { ODataQueryOptions } from "Analytics/Common/ODataQueryOptions";
import { IODataQueryResponse } from "Analytics/Shared/Common/Types";
import { latestODataVersion } from "Analytics/Common/Utilities/QueryUtilities";

const TestResourceEntityNames = {
    Points: "TestPoints",
    Suites: "TestSuites"
}

const TestPointFieldNames = {
    PlanId: "TestPlanId",
}

export interface ITestPlanProgressSummary {
    ExecPct: number;
    PassedPct: number;
    TotalCount: number;
}

/*
   TestPlanResultsSource: Util to get test plan progress report summary data using OData api.
*/
export class TestPlanResultsSource extends AnalyticsODataClientBase {

    public getTestPlanProgressSummary(planId: number): Promise<ITestPlanProgressSummary> {
        let filterStr = this._getFilterString(planId);
        let groupByStr = this._getGroupByStr();

        const queryOptions = {
            entityType: TestResourceEntityNames.Points,
            project: this._getProjectId(),
            oDataVersion: latestODataVersion
        } as ODataQueryOptions;
        
        queryOptions.$apply = `${filterStr}/${groupByStr}`;

        return this.queryOData(queryOptions).then((oDataQueryResponse: IODataQueryResponse) => {
            return Promise.resolve(this._createTestPlanProgressSummary(oDataQueryResponse));
        });

    }

    private _getFilterString(planId: number): string {
        return `filter(${TestPointFieldNames.PlanId} eq ${planId})`;
    }

    private _getGroupByStr() {
        return `aggregate($count as TotalCount, 
        cast(LastResultOutcome eq 'Passed', Edm.Int32) with sum as Passed, 
        cast(LastResultOutcome eq 'None', Edm.Int32) with sum as NotExecuted,
        cast(LastResultOutcome ne 'None', Edm.Int32) with sum as Executed)/compute(Executed mul 100 div TotalCount as ExecPct,
        iif(TotalCount gt NotExecuted, Passed mul 100 div Executed,0) as PassedPct)`;
    }

    private _createTestPlanProgressSummary(odataQueryResponse: any): ITestPlanProgressSummary {

        var response: ITestPlanProgressSummary = {
            ExecPct: 0,
            PassedPct: 0,
            TotalCount: 0
        } as ITestPlanProgressSummary;

        if (!odataQueryResponse || !odataQueryResponse.value) {
            throw new Error("Data is empty");
        }

        odataQueryResponse.value.forEach((row: ITestPlanProgressSummary) => {
                response.ExecPct = isNaN(row.ExecPct) ? 0 : row.ExecPct,
                response.PassedPct = isNaN(row.PassedPct) ? 0 : row.PassedPct,
                response.TotalCount = row.TotalCount
        });

        return response;
    }

}
